<template>
  <div class="edit-event-dialog">
    <v-dialog v-model="open" width="400" persistent>
      <v-card class="event-form">
        <v-card-title class="p-3 mb-5" color="primary">
          <v-icon class="mr-3" @click="close">
            mdi-close
          </v-icon>
          {{ $t('PublishEventToWingDialog.PublishTo') }}
        </v-card-title>
        <v-card-text>
          <v-select :items="wings" item-text="name" item-value="value" v-model="wing" autocomplete ref="wing"
            :label="$t('GeneralTranslations.Wing')">
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="publish">
            {{ $t('NewCalendarItem.Publish') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@/plugins/vee-validate";
import { EventLocations } from "@/enums/EventLocations";

export default {
  components: {
  },
  props: {
    wing: String,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      selectedWing: '',
    };
  },

  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    eventLocations() {
      return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type !== EventLocations.Wing);
    },
    wings() {
      return [{ name: this.$t('GeneralTranslations.All'), value: this.$t('GeneralTranslations.All'), type: EventLocations.Wing}].concat(this.eventLocations.filter(x => x.type === EventLocations.Wing).map(x => ({ name: x.name, value: x.name })));
    }
  },

  async created() {
    if (!this.eventLocations?.length) {
      await this.$store.dispatch("getEventLocations");
    }
    
    this.selectedWing = this.wing
  },

  methods: {
    publish() {
      this.$emit("onClosePablishToWingDialod", this.wing);
      this.close()
    },
    close() {
      this.open = false
    }
  }
};
</script>

<style scoped></style>
